// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610020519/js/" + chunkId + "." + {"44":"70b08233","225":"74ce4d9e","481":"cc17ea6a","486":"b8f9e17f","770":"a77bb1f6"}[chunkId] + ".0.9999987713941798.chunk.js";
};